export const slugify = (value, fallback = 'produit') => {
  const slug = String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

  return slug || fallback;
};

export const getProductPath = (product) => {
  if (!product?.id) return '/shop';

  const category = slugify(product.category, 'catalogue');
  const subcategory = slugify(product.subcategory, 'produits');
  const productName = slugify(product.name, 'produit');

  return `/produit/${category}/${subcategory}/${productName}-${product.id}`;
};

export const getProductIdFromSlug = (slug) => {
  const match = String(slug || '').match(/-(\d+)$/);
  return match ? match[1] : null;
};
